var map = {
	"./CasualIcon.vue": [
		9265,
		265
	],
	"./ChatIcon.vue": [
		5524,
		524
	],
	"./HomeIcon.vue": [
		1302,
		302
	],
	"./ProfileIcon.vue": [
		8982,
		982
	],
	"./PuzzleIcon.vue": [
		866,
		866
	],
	"./QuizIcon.vue": [
		9287,
		287
	],
	"./StatIcon.vue": [
		3659,
		659
	],
	"./TagIcon.vue": [
		2074,
		74
	],
	"./TetrisIcon.vue": [
		3687,
		687
	],
	"./TrophyIcon.vue": [
		6118,
		118
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4749;
module.exports = webpackAsyncContext;